module.exports = __webpack_public_path__ + "static/media/Prompt-Medium.bd536c63.ttf";